module.exports = __webpack_public_path__ + "static/media/1.e1a7d4ca.jpg";